import { Pipe, PipeTransform } from '@angular/core';
import { Currency, DiscountType } from '@galaxy/billing';
import { BillingFrequency, formatDisplayPrice } from '@vendasta/shared';

@Pipe({ name: 'price' })
export class PricePipe implements PipeTransform {
  transform(
    value: any,
    currency: Currency,
    billingFrequency?: BillingFrequency,
    isCents = true,
    translateZero = true,
    displaySymbol = true,
  ): any {
    return formatDisplayPrice(value, currency, billingFrequency, isCents, translateZero, displaySymbol);
  }
}

@Pipe({ name: 'toString' })
export class ToStringPipe implements PipeTransform {
  transform(value: any, f: (v: any) => string): any {
    return f(value);
  }
}

/*
 * Format discount amount for display.
 *
 * Usage:
 *   amount | formatDiscountAmount: discountType
 * Examples:
 *   {{ 500 | formatDiscountAmount: 'FIXED_AMOUNT':'USD' }}
 *   formats to: $5.00
 *
 *   {{ 15 | formatDiscountAmount: 'PERCENT_AMOUNT':'USD' }}
 *   formats to: 15%
 */
@Pipe({ name: 'discount' })
export class DiscountPipe implements PipeTransform {
  transform(amount: number, rule: DiscountType, currency: Currency): string {
    return formatDiscountAmount(amount, rule, currency);
  }
}

export function formatDiscountAmount(amount: number, rule: DiscountType, currency: Currency): string {
  if ([DiscountType.FIXED_AMOUNT, DiscountType.FIXED_AMOUNT_PER_UNIT].includes(rule)) {
    return formatDisplayPrice(amount, currency, null, true, false, 'symbol-narrow', false);
  } else if (rule === DiscountType.PERCENT_AMOUNT) {
    return amount.toString() + '%';
  }
  return amount.toString();
}
